module dg.objects {

    export class Base64FileController implements ng.IController {
        public ngModel: ng.INgModelController;
        public propMeta: restfulApi.DomainObjectPropertiesMetadata;
        public value: dg.domain.files.Base64FileInfo;
        public objectEditorCtrl: ObjectEditorController;

        private file: any;
        constructor(
            private $element: ng.IAugmentedJQuery,
            private $base64: any) {

            let fileHtmlElement = angular.element('input[type=file]', $element);
            //console.log('constructor');


            fileHtmlElement.bind("change", changeEvent => {
            
                let reader = new FileReader();
                reader.onload = loadEvent => {
                    let textResult = loadEvent.target["result"];
                    let base64Text = $base64.encode(textResult);
                    this.value = {
                        fileName: this.file.name,
                        data: base64Text,
                        domainType: "Base64FileInfo"
                    };
                    this.ngModel.$setViewValue(this.value);
                }
                this.file = changeEvent.target["files"][0];
                reader.readAsBinaryString(this.file);
            });
        }

        $onInit() {

        }

     //   scope.file = scope.fileHtmlElement.files[0];
    //                    var fileReader = new FileReader();
    //                    fileReader.readAsBinaryString(scope.file);
    //                    fileReader.onload = function (event) {
    //                        var textResult = event.target["result"];
    //                        var base64Text = $base64.encode(textResult);


    //                        ngModel.$setViewValue({ data: base64Text, fileName: scope.file.name });
    //                        scope.$apply(function () {
    //                            deffered.resolve(({ base64Text: base64Text, filename: scope.file.name }));
    //                        });
    //                    };

        public test = () => {
            let a = !!this.$element;
        }
        //element.bind("change", function(changeEvent) {
        //    var reader = new FileReader();
        //    reader.onload = function (loadEvent) {
        //        scope.$apply(function () {
        //            scope.fileread = loadEvent.target.result;
        //        });
        //    }
        //    reader.readAsDataURL(changeEvent.target.files[0]);
        //});
    }

    angular.module('dg.objects').component('base64File', {
        bindings: {
            value: '=ngModel',
            propMeta: '<'
        },
        require: {
            ngModel: 'ngModel',
            domainObjectCtrl: '^objectEditor'
        },
        controller: Base64FileController,
        template: '<input ng-model="$ctrl.value" type="file" class="form-control" ng-disabled="$ctrl.propMeta.readOnly || $ctrl.domainObjectCtrl.disabledActions.all"/>',
    });

    //angular.module('dg.objects')
    //    .directive('base64File', ['$q', '$base64', function ($q, $base64) {
    //        return {
    //            require: ['ngModel'],
    //            scope: {
    //                value: '=ngModel'
    //            },
    //            template: '<input type="file">',
    //            link: function (scope, element, attrs, ctrls) {

    //                var ngModel = <ng.INgModelController>ctrls[0];
    //                scope.fileHtmlElement = angular.element('input[type=file]', element)[0];

    //                scope.upload = function () {
    //                    scope.getFileData().then(base64Data => {
    //                        //todo
    //                        //$scope.upload.data = base64Data;
    //                        //$scope.$close(base64Text)...
    //                        scope.$close(base64Data);
    //                    });
    //                };

    //                scope.getFileData = function () {
    //                    var deffered = $q.defer();

    //                    if (!scope.fileHtmlElement.files || scope.fileHtmlElement.files.length == 0) {
    //                        deffered.resolve('');
    //                        return deffered.promise;
    //                    }
    //                    scope.file = scope.fileHtmlElement.files[0];
    //                    var fileReader = new FileReader();
    //                    fileReader.readAsBinaryString(scope.file);
    //                    fileReader.onload = function (event) {
    //                        var textResult = event.target["result"];
    //                        var base64Text = $base64.encode(textResult);


    //                        ngModel.$setViewValue({ data: base64Text, fileName: scope.file.name });
    //                        scope.$apply(function () {
    //                            deffered.resolve(({ base64Text: base64Text, filename: scope.file.name }));
    //                        });
    //                    };
    //                    return deffered.promise;
    //                };
    //            }
    //        };
    //    }]);
}